import api from '../../api/http-common'

const getOptions = () =>
  api.post('/milk-billing/get-options-data')

const getFarmerGroups = (data) =>
  api.post('/milk-billing/get-farmer-groups', data)

const getExportInfo = (data) =>
  api.post('/milk-billing/get-export-info', data)

const getExport = (data) =>
  api.post('/milk-billing/get-file', data)

const MilkPaymentService = {
  getExport,
  getExportInfo,
  getFarmerGroups,
  getOptions
}

export default MilkPaymentService